import {Badge} from "@mantine/core";
import {I18n} from "@aws-amplify/core";
import {UsageEvent} from "../types.ts";
import {billableStatus} from "../utils/billableStatus.ts";

const PRESENTATION = {
    UNRESOLVED_CUSTOMER: {color: 'orange', label: 'Unresolved customer'},
    UNMETERED: {color: 'yellow', label: 'Unmetered'},
    BILLABLE: {color: 'green', label: 'Billable'},
} as const;

// The status itself is derived in utils/billableStatus, which the Status sort also uses.
export const BillableBadge = ({record}: { record: Pick<UsageEvent, 'unresolvedCustomer' | 'unmetered'> }) => {
    const {color, label} = PRESENTATION[billableStatus(record)];
    return <Badge color={color}>{I18n.get(label)}</Badge>;
};
